<template>
<div class="chapter">
<div class="inner_page">
<h2 title="Dedication"> </h2>
<p class="sectiontop" style="text-align: center;">For the one who listened to a crazy idea on a summer afternoon and said yes</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 1_BTT_Dedication.vue?7d235631